/** VariantLoading 尺寸类型 */
export type VariantLoadingSize = 'sm' | 'md' | 'lg';

/** 图形类加载动画 Props */
export interface VariantLoadingSizeProps {
  className?: string;
  size?: VariantLoadingSize;
}

/** 文本类加载动画 Props */
export interface VariantLoadingTextProps {
  text?: string;
  className?: string;
  size?: VariantLoadingSize;
}

/**
 * 尺寸配置（单位：px）
 */
export const SIZE_CONFIG = {
  sm: {
    circular: 16,
    classic: 16,
    pulse: 16,
    pulseDot: 4,
    dot: 6,
    typingDot: 4,
    waveBar: 2,
    barWidth: 4,
    barHeight: 16,
    terminalCursorWidth: 6,
    terminalCursorHeight: 12,
    terminalText: 12,
    text: 12,
  },
  md: {
    circular: 20,
    classic: 20,
    pulse: 20,
    pulseDot: 8,
    dot: 8,
    typingDot: 6,
    waveBar: 2,
    barWidth: 6,
    barHeight: 20,
    terminalCursorWidth: 8,
    terminalCursorHeight: 16,
    terminalText: 14,
    text: 14,
  },
  lg: {
    circular: 24,
    classic: 24,
    pulse: 24,
    pulseDot: 12,
    dot: 10,
    typingDot: 8,
    waveBar: 4,
    barWidth: 8,
    barHeight: 24,
    terminalCursorWidth: 10,
    terminalCursorHeight: 20,
    terminalText: 16,
    text: 16,
  },
} as const;

export type SizeConfigType = typeof SIZE_CONFIG;

/**
 * 边框宽度配置
 */
export const BORDER_WIDTH = {
  sm: 2,
  md: 2,
  lg: 2,
} as const;

/**
 * 经典 Loading 配置
 */
export const CLASSIC_LOADER_CONFIG = {
  barCount: 12,
  rotationStep: 30,
  animationDelay: 0.1,
} as const;

/**
 * 点数量配置
 */
export const DOTS_COUNT = 3;

/**
 * Wave 条数量配置
 */
export const WAVE_BAR_COUNT = 5;

/**
 * Wave 高度配置（单位：px）
 */
export const WAVE_HEIGHTS: Record<VariantLoadingSize, number[]> = {
  sm: [6, 9, 12, 9, 6],
  md: [8, 12, 16, 12, 8],
  lg: [10, 15, 20, 15, 10],
};

/**
 * 动画延迟配置
 */
export const ANIMATION_DELAYS = {
  dots: 160,
  typing: 250,
  wave: 100,
  bars: 200,
  loadingDots: 200,
} as const;
